export enum LORRY_POSTING_FORM_LOCATION_STATE {
    PARAM_NAME = "lorry-posting-form"
}
